type EncryptedPayload = {
  content: string;
  iv: string;
  tag: string;
  keyHex: string;
};

export async function decryptMessage({
  content,
  iv,
  tag,
  keyHex,
}: EncryptedPayload): Promise<any> {
  const contentBytes = hexToBytes(content);
  const ivBytes = hexToBytes(iv);
  const tagBytes = hexToBytes(tag);
  const keyBytes = hexToBytes(keyHex);

  const alg: AesGcmParams = {name: 'AES-GCM', iv: ivBytes};

  const cryptoKey = await crypto.subtle.importKey('raw', keyBytes, alg, false, [
    'decrypt',
  ]);

  // AES-GCM expects the tag to be appended to ciphertext
  const dataWithTag = new Uint8Array([...contentBytes, ...tagBytes]);

  const decryptedBuffer = await crypto.subtle.decrypt(
    alg,
    cryptoKey,
    dataWithTag,
  );
  const decoded = new TextDecoder().decode(decryptedBuffer);
  return JSON.parse(decoded);
}

function hexToBytes(hex: string): Uint8Array {
  if (hex.length % 2 !== 0) {
    throw new Error('Invalid hex string');
  }
  return new Uint8Array(hex.match(/.{1,2}/g)!.map(byte => parseInt(byte, 16)));
}
